import { normalizeLocale as e } from "../config.mjs";
import { useLocaleAdapter as t } from "../adapter/LocaleAdapterContext.mjs";
import { changeLanguage as n, i18n as r } from "../i18n.mjs";
import { useCallback as i } from "react";
//#region src/hooks/useChangeLanguage.ts
var a = () => {
	let a = t();
	return i((t) => {
		let i = e(t);
		!i || i === r.language || (n(i), a.persistLocale(i));
	}, [a]);
};
//#endregion
export { a as useChangeLanguage };
